import React, { useState, useRef, useCallback, useEffect, use } from 'react';
import WebcamHandler, { WebcamControls } from './WebcamHandler';
import ImagePreview from './ImagePreview';
import LoadingSpinner from './LoadingSpinner';
import ErrorAlert from './ErrorAlert';

import { WarehouseIcon } from '../uitools/Icons';
import { Tool, ToolHistory, Users, Warehouse } from '../../types';
import { RESTHISTORY, RESTHISTORYPERUSERID, RESTME, RESTPOSTHISTORY, RESTPOSTTOOL, RESTRELEASEHISTORY, RESTTOOL, RESTTOOLPERUSERID, RESTUPDATETOOL, RESTWAREHOUSES } from '../../constants';
import { G } from 'react-router/dist/development/register-DCE0tH5m';

// Simple SVG Icon Components
const CameraIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`w-5 h-5 ${className}`}>
    <path d="M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z" />
    <path fillRule="evenodd" d="M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.426 1.458 2.426 2.917V17.08c0 1.46-1.002 2.679-2.437 2.918a48.849 48.849 0 0 1-1.147.176c-.463.067-.868.328-1.11.71l-.82 1.318a2.996 2.996 0 0 1-2.332 1.39 49.493 49.493 0 0 1-5.312 0 2.996 2.996 0 0 1-2.332-1.39l-.82-1.318c-.24-.383-.646-.643-1.11-.71a48.859 48.859 0 0 1-1.147-.176c-1.434-.239-2.437-1.458-2.437-2.917V8.57c0-1.46 1.003-2.679 2.437-2.918a48.851 48.851 0 0 1 1.147-.176c.463-.067.868-.328 1.11-.71l.82-1.317A2.996 2.996 0 0 1 9.344 3.07Z" clipRule="evenodd" />
  </svg>
);

const SparklesIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`w-5 h-5 ${className}`}>
        <path fillRule="evenodd" d="M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.426 1.458 2.426 2.917V17.08c0 1.46-1.002 2.679-2.437 2.918a48.849 48.849 0 0 1-1.147.176c-.463.067-.868.328-1.11.71l-.82 1.318a2.996 2.996 0 0 1-2.332 1.39 49.493 49.493 0 0 1-5.312 0 2.996 2.996 0 0 1-2.332-1.39l-.82-1.318c-.24-.383-.646-.643-1.11-.71a48.859 48.859 0 0 1-1.147-.176c-1.434-.239-2.437-1.458-2.437-2.917V8.57c0-1.46 1.003-2.679 2.437-2.918a48.851 48.851 0 0 1 1.147-.176c.463-.067.868-.328 1.11-.71l.82-1.317A2.996 2.996 0 0 1 9.344 3.07ZM11.625 10.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75ZM10.125 12a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75ZM13.125 12a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75ZM11.625 13.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75ZM10.125 15a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75ZM13.125 15a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z" clipRule="evenodd" />
        <path d="M10.06 5.514c.074-.669.726-1.163 1.434-1.163s1.36.494 1.434 1.163L13.16 7.75h2.079a.75.75 0 0 1 .624 1.153l-1.346 2.768a.75.75 0 0 0 .026.796l.025.039.008.012c.074.11.14.228.196.354l.003.005c.451.989.017 2.176-.926 2.687a.75.75 0 0 1-.96-.348l-.002-.005a6.723 6.723 0 0 0-.31-.603l-.004-.007a.75.75 0 0 0-.57-.39H9.777a.75.75 0 0 0-.57.39l-.004.007a6.725 6.725 0 0 0-.31.603l-.002.005a.75.75 0 0 1-.96.348c-.943-.511-1.377-1.698-.926-2.687l.003-.005a3.25 3.25 0 0 0 .196-.354l.008-.012.025-.039a.75.75 0 0 0 .026-.796L6.298 8.903a.75.75 0 0 1 .624-1.153H9.002l.238-2.139.82-1.1Z" />
    </svg>
);

interface GenericIntf {
  token: string,
}

const ObjectReturn: React.FC<GenericIntf> = ({token}) => {
  const [isWebcamActive, setIsWebcamActive] = useState<boolean>(false);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  
  //const [description, setDescription] = useState<string>("");
  const [refresh, setRefresh] = useState<number>(0);
 
  const [notes, setNotes] = useState<string>("");
  const [code, setCode] = useState<string>("");

  const [apiResult, setApiResult] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const [selectedToolId, setSelectedToolId] = useState<number | null>(null);

  const [selectedWarehouseId, setSelectedWarehouseId] = useState<number>();
  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  
  const [history,setHistory] = useState<ToolHistory[]>([]); 
  const [tools,setTools] = useState<Tool[]>([]);
  const [me,setMe] = useState<Users>();

  const webcamRef = useRef<WebcamControls>(null);

  const handleToggleWebcam = useCallback(() => {
    setIsWebcamActive(prev => !prev);
    if (isWebcamActive) { // If it was active, now it's being turned off
      setCapturedImage(null); // Clear image if webcam is turned off
      setApiResult(null); // Clear previous results
    }
    setError(null); // Clear errors when toggling webcam
  }, [isWebcamActive]);

  const handleCaptureImage = useCallback(() => {
    if (webcamRef.current) {
      setError(null);
      setApiResult(null);
      webcamRef.current.capture();
    }
  }, []);

  
  useEffect(()=>{
 
    const fetchhistory = async()=>{
      const response = await RESTHISTORYPERUSERID(token);
      if(response!==null && response.length > 0){
        setHistory(response.filter(h => h.released === null));
      } else {
        setHistory([]);
      }
      
    };
    const fetchwarehouse = async()=>{
      const response = await RESTWAREHOUSES(token);
      setWarehouses(response);
    };
    const fetchtool = async()=>{
      const response = await RESTTOOLPERUSERID(token);
      
      setTools(response);
    };
    const fetchme = async()=>{
      const response = await RESTME(token);
      setMe(response);
      if(response.id){
        
        fetchwarehouse();
        fetchtool();
        fetchhistory();
      }
    }
    fetchme();
    
  },[token,refresh]);

  const handleImageCaptured = useCallback((imageBase64: string) => {
    setCapturedImage(imageBase64);
    // setIsWebcamActive(false); // Optionally stop webcam after capture
  }, []);

  const handleClearImage = useCallback(() => {
    setCapturedImage(null);
    setApiResult(null);
    setError(null);
  }, []);

  const handleSubmitToApi = async () => {
    if (!capturedImage) {
      setError("Nessuna immagine catturata da inviare.");
      return;
    }
    /*if (!description.trim()) {
      setError("La descrizione non può essere vuota.");
      return;
    }*/
    if (!notes.trim()) {
      setError("Le note non possono essere vuote.");
      return;
    }
    /*if (!code.trim()) {
      setError("Il codice a barre/rfid non può essere vuoto.");
      return;
    }*/
    setIsLoading(true);
    setError(null);
    setApiResult(null);

    try {
      const newTool:Tool = tools.find( t => t.id===selectedToolId)!;
      //newTool.warehouse = selectedWarehouseId!;

      const newHist:ToolHistory = history.find(h => h.toolid === selectedToolId)!;
      newHist.releasenote = notes;
      newHist.releaseimgsrc = capturedImage.split(',')[1];
          
      const fetchhistandtool = async(ntool:Tool,nhist:ToolHistory)=>{
        const respa = await RESTRELEASEHISTORY(nhist, token);
        //const respb = await RESTUPDATETOOL(ntool, token);
        //setApiResult(respa.txt!);
        setCapturedImage(null);
        
        setIsLoading(false);
        setSelectedToolId(null);
        setRefresh(refresh+1);
        setNotes("");
        setCode("");
        setIsWebcamActive(false);
      };
      
      fetchhistandtool(newTool,newHist);
      
    } catch (err) {
      console.error(err);
      setError(err instanceof Error ? err.message : "Errore sconosciuto durante l'analisi.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedToolId !== null) {
      setSelectedWarehouseId(tools.find(t => t.id === selectedToolId)?.warehouse!);
    }
  }, [selectedToolId, tools]);

  const handleWebcamError = useCallback((errorMessage: string) => {
    setError(errorMessage);
    setIsWebcamActive(false);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 text-gray-200 flex flex-col items-center p-4 sm:p-6 md:p-8">
      <header className="w-full max-w-4xl mb-8 text-center">
        {selectedToolId===null && (
          <div className="md:col-span-1">
            <label htmlFor="tool-select" className="block text-sm font-medium text-slate-300 mb-1">
              <WarehouseIcon className="w-5 h-5 inline mr-1.5 align-text-bottom" />Seleziona oggetto:
            </label>
            <select id="tool-select" value={selectedToolId||undefined}
                onChange={(e) => {setSelectedToolId(Number.parseInt(e.target.value) || null);}}
                className="w-full p-3 rounded-lg bg-slate-700 text-slate-200 border border-slate-600 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 outline-none"
            >
            <option value="">Scegli oggetto da restituire</option>
            {history.map(wh => (  <option key={wh.toolid} value={wh.toolid}>{tools.find(tool=> tool.id === wh.toolid)?.txt}</option>))}
            </select>
          </div>          
        )}
        {selectedToolId!==null && (
        <>
          <h1 className="text-4xl sm:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-blue-500">
            Inquadra e scatta la foto per {tools.find(tool=> tool.id === selectedToolId)?.txt}
          </h1>
          <p className="text-slate-400 mt-2 text-lg">
            Mantieni l'oggetto in primo piano.
          </p>
          <button onClick={()=>{setSelectedToolId(null)}}
                className="ml-2 text-xs text-slate-400 underline cursor-pointer hover:text-sky-300">
                Seleziona altro oggetto
          </button>
        </>
        )}
      </header>

      <main className="w-full max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-6">
      
       
        
        {/* Colonna Sinistra: Webcam e Controlli Immagine */}
        <div className="space-y-6 p-6 bg-slate-800/70 backdrop-blur-md shadow-xl rounded-xl">
          <div>
            <h2 className="text-2xl font-semibold mb-4 text-sky-400">Usa la webcam</h2>
            <WebcamHandler
              ref={webcamRef}
              isActive={isWebcamActive}
              onCaptureSuccess={handleImageCaptured}
              onError={handleWebcamError}
            />
            <div className="mt-4 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
              <button
                disabled={selectedToolId===null}  
                onClick={handleToggleWebcam}
                className={`w-full sm:w-auto flex items-center justify-center px-4 py-2.5 rounded-lg font-semibold text-white transition-all duration-200 ease-in-out disabled:bg-slate-600 disabled:cursor-not-allowed
                  ${isWebcamActive ? 'bg-red-600 hover:bg-red-700 shadow-md hover:shadow-lg' 
                                  : 'bg-blue-600 hover:bg-blue-700 shadow-md hover:shadow-lg'}
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-800 ${isWebcamActive ? 'focus:ring-red-500' : 'focus:ring-blue-500'}`}
              >
                <CameraIcon className="mr-2"/>
                {isWebcamActive ? 'Ferma Webcam' : 'Avvia Webcam'}
              </button>
              {isWebcamActive && (
                <button
                  
                  onClick={handleCaptureImage}
                  className="w-full sm:w-auto flex items-center justify-center px-4 py-2.5 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 shadow-md hover:shadow-lg transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-800 focus:ring-green-500"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2"><path d="M2.5 4A1.5 1.5 0 0 0 1 5.5V6h18v-.5A1.5 1.5 0 0 0 17.5 4h-15Z" /><path fillRule="evenodd" d="M1 7.5v7A1.5 1.5 0 0 0 2.5 16h15a1.5 1.5 0 0 0 1.5-1.5v-7H1ZM5.023 9.21A.75.75 0 0 1 5.75 8.5h8.5a.75.75 0 0 1 .727.71l.286 1.714a.75.75 0 0 1-.245.678l-.05.058a.75.75 0 0 1-.679.24l-1.26-.21a.75.75 0 0 0-.803.41l-.373.746a.75.75 0 0 1-.675.464H8.75a.75.75 0 0 1-.675-.464l-.373-.746a.75.75 0 0 0-.803-.41l-1.26.21a.75.75 0 0 1-.679-.24l-.05-.058a.75.75 0 0 1-.245-.678l.286-1.714Z" clipRule="evenodd" /></svg>
                  Cattura Immagine
                </button>
              )}
            </div>
          </div>

          {capturedImage && (
            <div>
              <h2 className="text-2xl font-semibold mb-3 text-sky-400">Immagine Catturata</h2>
              <ImagePreview imageSrc={capturedImage} onClearImage={handleClearImage} />
            </div>
          )}
        </div>

        {/* Colonna Destra: Prompt, Invio e Risultati */}
        <div className="space-y-6 p-6 bg-slate-800/70 backdrop-blur-md shadow-xl rounded-xl">
          
          <div>
            <h2 className="text-2xl font-semibold mb-3 text-sky-400">Codice a barre o RFID</h2>
            <textarea
              value={code}
              onChange={(e) => setCode(e.target.value)}
              rows={1}
              className="w-full p-3 bg-slate-700 border border-slate-600 rounded-lg text-gray-200 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition-colors placeholder-slate-400"
              placeholder="Es: E6D7889162..., ecc."
              disabled={!capturedImage || isLoading}
            />
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-3 text-sky-400">Note</h2>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={4}
              className="w-full p-3 bg-slate-700 border border-slate-600 rounded-lg text-gray-200 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition-colors placeholder-slate-400"
              placeholder="Es: Guasto, lame da sostituire, ecc."
              disabled={!capturedImage || isLoading}
            />
          </div>

          <label htmlFor="warehouse-select" className="block text-sm font-medium text-slate-300 mb-1">
            <WarehouseIcon className="w-5 h-5 inline mr-1.5 align-text-bottom" />Magazzino di rientro:
          </label>
          <div className='text-center w-full'> {warehouses.find(w => w.id === selectedWarehouseId!)?.name || 'N/A'  }</div>
          {false &&  <select id="warehouse-select"
                    value={selectedWarehouseId}
                    onChange={(e) => {setSelectedWarehouseId(Number.parseInt(e.target.value)) }}
                   className="w-full p-3 rounded-lg bg-slate-700 text-slate-200 border border-slate-600 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 outline-none"
             >
            {warehouses.map(wh => (<option key={wh.id} value={wh.id}>{wh.name}</option>))}
          </select>}

          <button
            onClick={handleSubmitToApi}
            disabled={!capturedImage || isLoading}
            className="w-full flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 disabled:bg-slate-600 disabled:cursor-not-allowed shadow-md hover:shadow-lg transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-800 focus:ring-purple-500"
          >
            {isLoading ? (
              <>
                <LoadingSpinner size="w-5 h-5" color="text-white" className="mr-2" />
                Connessione in corso...
              </>
            ) : (
              <>
                <SparklesIcon className="mr-2" />
                Invia
              </>
            )}
          </button>
          
          {error && <ErrorAlert message={error} onDismiss={() => setError(null)} />}

          {apiResult && !isLoading && (
            <div>
              <h2 className="text-2xl font-semibold mb-3 text-sky-400">Risposta server</h2>
              <div className="p-4 bg-slate-700 rounded-lg prose prose-invert max-w-none prose-sm text-gray-300 whitespace-pre-wrap">
                {apiResult}
              </div>
            </div>
          )}
        </div>
      </main>

      
    </div>
  );
};
/*
<div>
            <h2 className="text-2xl font-semibold mb-3 text-sky-400">Descrizione</h2>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={1}
              className="w-full p-3 bg-slate-700 border border-slate-600 rounded-lg text-gray-200 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition-colors placeholder-slate-400"
              placeholder="Es: Descrivi oggetto, ecc."
              disabled={!capturedImage || isLoading}
            />
</div>*/

export default ObjectReturn;